import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconCurveEasing12(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={12}
            height={12}
            className={customClassName}
            name="IconCurveEasing12"
            aria-hidden="true"
            {...props}
        >
            <g fill="currentColor">
                <path d="M8.5 4a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1M9 5.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0m0 2a.5.5 0 0 0-1 0 .5.5 0 0 1-.5.5h-4a.5.5 0 0 0 0 1h4A1.5 1.5 0 0 0 9 7.5" />
                <path
                    fillRule="evenodd"
                    d="M1 2.5A1.5 1.5 0 0 1 2.5 1h7A1.5 1.5 0 0 1 11 2.5v7A1.5 1.5 0 0 1 9.5 11h-7A1.5 1.5 0 0 1 1 9.5zM2.5 2h7a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-.5.5h-7a.5.5 0 0 1-.5-.5v-7a.5.5 0 0 1 .5-.5"
                    clipRule="evenodd"
                />
            </g>
        </svg>
    );
}
export default memo(IconCurveEasing12);
